module.exports = __webpack_public_path__ + "img/section4.3bd591a8.jpg";